// Angular modules
import { Component }       from '@angular/core';
import { Inject }          from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export class YesNoDialogData
{
  public Title   : string;
  public Content : string;

  constructor() { }
}

@Component({
  templateUrl : './yesno-dialog.component.html',
  styleUrls   : ['./yesno-dialog.component.scss']
})
export class YesNoDialogComponent
{
  constructor(@Inject(MAT_DIALOG_DATA) public data: YesNoDialogData) {}
}
